import React, { useState, useEffect } from "react"
import { nanoid } from "nanoid"

import { fbAuth } from "../../services/Firebase"
import { Swiper, SwiperSlide,  } from "swiper/react"
import SwiperCore, { EffectCoverflow, Pagination } from "swiper"
import "swiper/swiper-bundle.min.css"
import WineSlide from "./WineSlide"
import WinePage from "../../pages/wine/WinePage"
import Service from "../../services/Service"

SwiperCore.use([ EffectCoverflow, Pagination ])

function WineCarousel({ allWine, showWine, setShowRecipe }) {
    const [ wine, setWine ] = useState([])
    const [ showPage, setShowPage ] = useState( false )
    const [ favWine, setFavWine ] = useState([])
    let user = {}

    if (fbAuth.currentUser) {
        user = fbAuth.currentUser
    }

    useEffect(() => {
        const dataset = Service.getDataFromLS( `${user.uid}-wine` )
        setFavWine( dataset )
    }, [ user.uid ])

    useEffect(() => {
        const getWine = () => setWine(allWine)
        getWine()
    }, [ allWine ])

    const displayPage = () => {
        showPage ? setShowPage( false ) : setShowPage( true ) 
        setShowRecipe( prevState => !prevState )
    }

    return (
        <> {
            showPage
                ?   <WinePage 
                    allWine={wine} 
                    displayPage={displayPage} />
                :   showWine
                &&   <article className="carousel">
                    <h2>Wine of The Day</h2>
                    <Swiper
                        effect="coverflow"
                        pagination={{ clickable: true }}
                        spaceBetween={30}
                        slidesPerView={1}
                        loop="true"
                    >
                        {
                            wine.map( item => {
                                return  <SwiperSlide key={nanoid()} >
                                    <WineSlide 
                                        wine={item} 
                                        displayPage={displayPage} 
                                        favWine={favWine}
                                        setFavWine={setFavWine}
                                    />
                                </SwiperSlide>
                            })
                        }
                    </Swiper>
                </article>
        } </>
    )
}

export default WineCarousel
